import React from "react";
import Box from "@mui/material/Box";
import { IParticipationSummary } from "@Interfaces";
import { AttendeeWidget } from "./AttendeeWidget";
import { EngagementStatTiles } from "./EngagementStatTiles";
import { HighestEngagementQuestion } from "./HighestEngagementQuestion";
import { HowFarPeopleGot } from "./HowFarPeopleGot";
import { TotalNumbers } from "./TotalNumbers";

interface ParticipationWidgetsProps {
    channelId: string;
    summary: IParticipationSummary;
}

export const ParticipationWidgets: React.FC<ParticipationWidgetsProps> = ({
    channelId,
    summary,
}) => {
    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                    gap: "16px",
                }}
            >
                {/* Keyed so a half-typed count never carries over to another channel. */}
                <AttendeeWidget
                    key={channelId}
                    channelId={channelId}
                    summary={summary}
                />
                <EngagementStatTiles summary={summary} />
            </Box>

            <HighestEngagementQuestion summary={summary} />
            <HowFarPeopleGot summary={summary} />
            <TotalNumbers summary={summary} />
        </Box>
    );
};
